import * as React from 'react'
import * as ToastPrimitives from '@radix-ui/react-toast'

import { faXmark } from '@document-crunch/pro-regular-svg-icons'

import { cn } from '@dc-shared-web/lib'
import { Icon } from '@dc-shared-web/components/base/Icon'
import { Button } from '@dc-shared-web/components/shadcn/button'
import { Toast } from '@dc-shared-web/components/shadcn/toast'

const ToastAction = React.forwardRef<
  React.ElementRef<typeof ToastPrimitives.Action>,
  React.ComponentPropsWithoutRef<typeof ToastPrimitives.Action>
>(({ className, ...props }, ref) => (
  <ToastPrimitives.Action
    ref={ref}
    className={cn(
      'group-[.tw-destructive]:tw-border group-[.tw-destructive]:tw-border-white',
      className
    )}
    {...props}
    //Pass the toast action props and behavior down to the child
    asChild
  ></ToastPrimitives.Action>
))
ToastAction.displayName = ToastPrimitives.Action.displayName

const ToastClose = React.forwardRef<
  React.ElementRef<typeof ToastPrimitives.Close>,
  React.ComponentPropsWithoutRef<typeof ToastPrimitives.Close>
>(({ className, ...props }, ref) => (
  <ToastPrimitives.Close
    ref={ref}
    className={cn(
      'tw-rounded-md tw-transition-opacity tw-text-secondary-600 focus:tw-opacity-100 focus:tw-outline-none focus:tw-ring-2 group-hover:tw-opacity-100',
      'group-[.tw-destructive]:tw-text-destructive-foreground  group-[.tw-destructive]:focus:tw-ring-destructive',
      'group-[.tw-success]:focus:tw-ring-success',
      '[&_svg]:tw-text-secondary-600',
      '[&_svg]:group-[.tw-destructive]:tw-text-destructive-foreground',
      className
    )}
    {...props}
    asChild
  >
    <Button
      variant='ghost'
      size='icon'
      className='hover:tw-bg-transparent'
      aria-description='Close'
    >
      <Icon icon={faXmark} size='sm' />
    </Button>
  </ToastPrimitives.Close>
))
ToastClose.displayName = ToastPrimitives.Close.displayName

const ToastTitle = React.forwardRef<
  React.ElementRef<typeof ToastPrimitives.Title>,
  React.ComponentPropsWithoutRef<typeof ToastPrimitives.Title>
>(({ className, ...props }, ref) => (
  <ToastPrimitives.Title
    ref={ref}
    className={cn('tw-text-sm tw-font-semibold', className)}
    {...props}
  />
))
ToastTitle.displayName = ToastPrimitives.Title.displayName

const ToastDescription = React.forwardRef<
  React.ElementRef<typeof ToastPrimitives.Description>,
  React.ComponentPropsWithoutRef<typeof ToastPrimitives.Description>
>(({ className, ...props }, ref) => (
  <ToastPrimitives.Description
    ref={ref}
    className={cn(
      'tw-text-2xs tw-text-neutral-400',
      'group-[.tw-destructive]:tw-text-destructive-foreground',
      className
    )}
    {...props}
  />
))
ToastDescription.displayName = ToastPrimitives.Description.displayName

type ToastProps = React.ComponentPropsWithoutRef<typeof Toast>

type ToastActionElement = React.ReactElement<typeof ToastAction>

export {
  type ToastProps,
  type ToastActionElement,
  ToastTitle,
  ToastDescription,
  ToastClose,
  ToastAction,
}
